// src/pages/Contact/ContactPageStyles.js
import styled from "styled-components";

import ornament from "../../assets/images/ornament.png"; // <- adaugă asta
import ornament3 from "../../assets/images/ornament3.png"; // <- adaugă asta

const gold = "#c4a453";
const ink = "#1e1b16";
const paper = "#fffdfa";

export const PageWrap = styled.main`
  width: 100%;
  overflow: visible;
  isolation: isolate;

  display: grid;
  gap: 32px;
`;

export const Section = styled.section`
  width: min(1200px, 94vw);
  margin: 0 auto 0px;
`;

export const Section2 = styled.section`
  background: radial-gradient(
      60% 60% at 50% 38%,
      rgba(0, 0, 0, 0.04),
      transparent 60%
    ),
    #f6f4ef;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 28px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftCol = styled.div`
  display: grid;
  gap: 16px;
`;

export const RightCol = styled.div`
  display: grid;
  gap: 22px;
  @media (max-width: 960px) {
    margin-top: 0; /* pe mobil revine sus, sub formular */
  }
`;

export const SectionTitle = styled.h2`
  font-size: clamp(28px, 3.2vw, 40px);
  color: ${ink};
  margin: 8px 0 2px;
  letter-spacing: 0.3px;
`;

export const Ornament = styled.div`
  height: 8px;
  border-bottom: 2px dotted ${gold};
  opacity: 0.9;
`;

export const OrnamentGeneral = styled.div`
  height: 36px;
  background: url(${ornament3}) no-repeat center;
  background-size: contain;

  @media (max-width: 940px) {
    background: url(${ornament}) no-repeat center;
    height: 42px;
    background-size: contain;
  }
`;
